import React, { Component } from 'react';
import moment from 'moment';
import Notifications, {notify} from 'react-notify-toast';
import WaitingModal from '../../generics/WaitingModal';
import ModalPrintLabel from '../../generics/ModalPrintLabel';
import STData from './STData';
import ApheresisData from './ApheresisData';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import ModalHistorico from '../../generics/ModalHistorico';
import swal from 'sweetalert';
import {bin} from 'react-icons-kit/icomoon/bin';
import SvgIcon from 'react-icons-kit';
import {ic_local_offer} from 'react-icons-kit/md/ic_local_offer';
import { Table, Button } from 'react-bootstrap';
import MaskedFormControl from 'react-bootstrap-maskedinput';
import {download} from 'react-icons-kit/fa/download';
import ModalLiberacion from './ModalLiberacion';
import ModalNotes from '../../results_donation/components/ModalNotes';
import {pencilSquareO} from 'react-icons-kit/fa/pencilSquareO';

import Inputmask from 'inputmask';
import $, { isNumeric } from 'jquery';
import { print } from 'react-icons-kit/fa/print';

var Config = require('../../../config');
var socket = "";


class FormExtractions extends Component{
	constructor(props, context) {
		super(props, context);

		this.onIncidentSelected = this.onIncidentSelected.bind(this);
		this.getSTObj = this.getSTObj.bind(this);
		this.getApheresisObj = this.getApheresisObj.bind(this);
		this.addIncident = this.addIncident.bind(this);
		this.onClickDownload = this.onClickDownload.bind(this);
		this.onLabelClick    = this.onLabelClick.bind(this);
		this.onHourChange = this.onHourChange.bind(this);
		this.onDateChange = this.onDateChange.bind(this);
		this.onVolumeChange = this.onVolumeChange.bind(this);
		this.doubleCheck = this.doubleCheck.bind(this);
		this.deleteMsg = this.deleteMsg.bind(this);
		this.validateInput = this.validateInput.bind(this);
		this.editOffer = this.editOffer.bind(this);
		this.getDonationTypes = this.getDonationTypes.bind(this);
		this.labelService = this.labelService.bind(this);
		this.onValueChange = this.onValueChange.bind(this);
		this.printAferesis = this.printAferesis.bind(this);

		//Definicion de variables
		this.state = { 
			donor:{
				donor:{donor_number:""},
				person:{sex:"",civil_status:"",job_profile:"", scholarship:""},
				offer:{donation_type:"",extraction_type:""},
				mpio:{},
				state:{},
				document:{document:{}, document_type_value:""},
			},
			offer:{
				item:{id:""},
				convoke_places_name:"",
				type_donation_name:"",
				type_extraction_name:"",
				timestamp_date:""
			},
			timestamp_date:"",
			timestamp_hour:"",

			original_date:"",
			
			//formar variable
			donation: {
				equipment_id:"",
				tube : "0",
				arm : "",
				bag_flag  : "1",
				blood_bags_id:"",
				validated: false
			},
			volume: "",
			apheresis_kits_id : "",

			unit:[],
			lote_number:"",
			lote_number_local:"",
			local_number:"",

			incident:{
				key:"",
				text:""
			},
			incident_type:{
				id:"",
				text:""
			},

			incidents_list:[],

			incident_ids:[],
			method:'post',
			incident_id:"",
			
			equipments: [], //preguntar si estos se pueden quedar
			apheresis: [],//preguntar
			component_kit:[],
			asigned_kit:[],

			arms: [],
			blood_bags: [],

			incidents_category:[],
			disable_incidents_cat : false,
			incidents_type:[],

			medical_staff_id:"",
			staff:[],

			show_group_rh:false,
			age:"",
			start_hour:"",
			end_hour:"",
			cycle_number:"",
			volume_anticoagulant:"",
			lote_anticuagulant:"",
			platelet_performance:"",
			equivalent_units:"",
			equivalent_units_double:"",
			colorBtnHistory:"green",

			show_num_donation:false,
			donation_number:"",
			hideFieldsAph : false,
			extraction_time:"",
			disabled_element:true,
			double:false,
			disableLiberation: true,
			can_be_edit:true,
			show_enable_button:false,
			edit_extraction_type:false,
			donation_type_id:"",
			extraction_type_id:"",
			extraction_types:[],
			donation_types:[],
			preview_print:{},
			don_days_offer:{},
			days_after_register:"",
			valid_days:true,
			flag_notes:false,
			show_promotion:false,
			min_ext:"",
			donation_id:"",
		}
	}

	//Consulta de servicios necesarios para la pantalla
	componentDidMount() {
		$(document).on('blur', '.input-date', (e)=>{
			var date = moment(e.target.value, 'DD/MM/YYYY').format('YYYY-MM-DD');
			
			if(e.target.value !== ""){
				if(date === 'Invalid date' || date === 'Fecha inválida'){
					swal('Error', 'Debes ingresar un valor válido. El campo está incompleto o contiene una fecha no válida.', 'error');

					$('#'+e.target.id).addClass('error');

					setTimeout(()=>{
						$('#'+e.target.id).val('');
						e.target.value = "";
						
						this.dateHandleChange(e);
					}, 3500)
				}else{
					$('#'+e.target.id).removeClass('error');
				}
			}else{
				$('#'+e.target.id).removeClass('error');
			}
		});


		this.props.onRef(this);
		if(this.props.location.pathname.indexOf('promotion') !== -1){
	        this.setState({show_promotion:true});
	      }
		this.waiting_modal.handleShow('Cargando...');
		
		var user_task = JSON.parse(sessionStorage.getItem("task_has_user_profiles"));
	    user_task.map((user)=>{
	      	if(user.type !== undefined){
	        	if(user.type==='RELEASE_UNITS'){
	          		this.setState({disableLiberation: false});
	        	}
	      	}
	    });

		socket = this.props.socket !== undefined && this.props.socket !== "" ?
								this.props.socket 
						: new WebSocket("wss://localhost:2018");

		socket.onerror = (event)=> {

		};

		socket.onmessage = (event) => {
		    var res = JSON.parse(event.data);
		    if(res.Error !== undefined){
		    	swal('¡Error!', res.Error, 'error');
		    }

		}

		fetch(Config.default.apiGateway.URL+'functional_criterion?code=PROC_EXT_CE&x=',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				proc_ext_ce: response
			});
		})
		fetch(Config.default.apiGateway.URL+'functional_criterion?code=PROC_EXT_PLASMA&x=',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				proc_ext_plasma: response
			});
		})
		fetch(Config.default.apiGateway.URL+'functional_criterion?code=PROC_EXT_PLAQ&x=',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				proc_ext_plaq: response
			});
		})


		//Criterio funcional,cambiar lugar de colecta
		fetch(Config.default.apiGateway.URL+'functional_criterion?code=lab_preview_print&x=',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				preview_print: response
			});
		})

		fetch(Config.default.apiGateway.URL+'functional_criterion?code=DON_DAYS_OFFER&x=',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				don_days_offer: response
			});
		})

		fetch(Config.default.apiGateway.URL+'offers/days_after_register?offers_id='+
			this.props.match.params.offers_id,{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				days_after_register: response
			});
		})

		//TIPOS DE EXTRACCION
		fetch(Config.default.apiGateway.URL+'donation_type_extraction',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error!', "Tipos Extracción: "+result, 'error');
	          });
        }})
		.then(response => {
			this.setState({extraction_types: response});
		})

		//Get Current Date from Server
		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			var aux = response.split('|');
			
			var hours = this.getHourFormat(aux[1]);
			this.setState({
				timestamp_date:aux[0],
				timestamp_hour:hours,
				original_date:aux[0]
			});
		})

		//separador
		fetch(Config.default.apiGateway.URL+'equipments/actives?type=SEPARADOR_CELULAR',{
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer ' + sessionStorage.getItem("token"),
				'Accept' 		: 'application/json',
				'Content-Type'	: 'application/json', 
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			this.setState({equipments: response});
		})

		//lookups?type=arm_type&notrender=0 brazo
		fetch(Config.default.apiGateway.URL+'lookups?type=arm_type&notrender=0',{
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer ' + sessionStorage.getItem("token"),
				'Accept' 		: 'application/json',
				'Content-Type'	: 'application/json', 
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			this.setState({arms: response});
		});

		// incident category lookups?type=incident_type&notRender=0
		fetch(Config.default.apiGateway.URL+'lookups?type=incident_type&notRender=0',{
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer ' + sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			}) 
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			this.setState({incidents_category: response});
			this.selectIncident();
		})

		//responsable
		fetch(Config.default.apiGateway.URL+'medical_staff?option=mainInfo&type=NURSE', {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept' 		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response =>{
			this.setState({staff: response});
		})

		
		
		setTimeout(()=>{
			
			if(this.props.match.params.donation_id !== '0'){
				fetch(Config.default.apiGateway.URL+'donations?id='+this.props.match.params.donation_id, {
					method: 'get', // or 'PUT'
					//body: JSON.stringify({offers_id:this.state.offer.item.id}), // data can be `string` or {object}!
					headers: new Headers({
						'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
						'Accept': 'application/json',
						'Content-Type': 'application/json;charset=UTF-8'
					})
				})
				.then(res => {
	            if(res.ok){
	              return res.json();
	            }else{
	              res.text().then(function(result) {
	                swal('¡Error', result, 'error');
	              });
	            }})
				.then(response => {
					setTimeout(function(){

						var start_hour = response.donation.time_start !== null ? this.getHourFormat(response.donation.time_start.split('T')[1]) : ""
						var end_hour = response.donation.time_end !== null ? this.getHourFormat(response.donation.time_end.split('T')[1]) : ""
					
						this.setState({
							can_be_edit: response.can_be_edit,
							donation_number: response.donation.donation_number,
							disabled_element:false,
							show_num_donation: true,
							donation_id: response.donation.id,
							apheresis_kits_id:response.donation.apheresis_kits_id !== null ? response.donation.apheresis_kits_id : "",
							medical_staff_id:response.donation.users_id,
							donation:{
								arm:response.donation.arm !== null ? response.donation.arm.toLowerCase() : "",
								tube: response.donation.tube !== null ? response.donation.tube.toString() : "0",
								bag_flag:response.donation.bag_flag !== null ? response.donation.bag_flag : "1",
								blood_bags_id:response.donation.blood_bags_id !== null ? response.donation.blood_bags_id.toString() : "",
								equipment_id:response.donation.equipment_id !== null ? response.donation.equipment_id: "",
								validated: response.donation.validated
							},
							extraction_time:response.donation.extraction_time !== null ? parseFloat(response.donation.extraction_time) : "",
							volume: response.donation.volume !== null ? response.donation.volume: this.state.volume,
							lote_number:response.donation.lote_number !== null ? response.donation.lote_number : "",
							lote_number_local: response.donation.local_number !== null ? response.donation.local_number : "",
							local_number: response.donation.local_number !== null ? response.donation.local_number : "",
							cycle_number: response.donation.cycle_number !== null ? response.donation.cycle_number : "",
							lote_anticuagulant: response.donation.lote_anticuagulant !== null ? response.donation.lote_anticuagulant : "",
							platelet_performance: response.donation.platelet_performance !== null ? response.donation.platelet_performance : "",
							start_hour: start_hour,
							end_hour : end_hour,
							processed_blood: response.donation.proceced_blood != null ? response.donation.proceced_blood : "",
							volume_anticoagulant: response.donation.volume_anticoagulant !== null ? response.donation.volume_anticoagulant : "",
							equivalent_units: response.donation.equivalent_units !== null ? response.donation.equivalent_units : "",
							equivalent_units_double: response.donation.equivalent_units_double !== null ? response.donation.equivalent_units_double : "",
							double:response.donation.apheresis_double
						})

						if(response.donation.timestamp_date !== null){
							this.setState({
								timestamp_date: response.donation.timestamp_date !== null ?
												moment(response.donation.timestamp_date).format('DD/MM/YYYY') : "",
							});
						}

						if(response.donation.timestamp_hour !== null){
							this.setState({	
								timestamp_hour: response.donation.timestamp_hour !== null ?
												response.donation.timestamp_hour: ""
							});
						}	
						
						if(this.state.offer.type_extraction_name === "SANGRE TOTAL"){
							if((response.donation.blood_bags_id === null || response.donation.blood_bags_id === "") &&
								(response.donation.extraction_time === null || response.donation.extraction_time === "")){
								this.setState({valid_days: false});
							}
						}else{
							if(response.donation.apheresis_kits_id === null || response.donation.apheresis_kits_id === ""){
								this.setState({valid_days: false});
							}
						}



					}.bind(this), 500);
						
					
					if(response.unit.length > 0){
						var units = [];

						response.unit.map((u, i)=>{
							var index = response.equivalent_and_platelet_performance.findIndex(obj => 
								obj.unit_id === u.id	
							);	

							if(response.donation.volume === null){
								var volume = response.equivalent_and_platelet_performance.length > 0 ?
										index === -1 ? u.volume
										: response.equivalent_and_platelet_performance[index].volume
									: u.volume;
							}else{
								volume = response.donation.volume;
							}			

							if(units.length === 0){
								units.push([{
									unit:1,
									donation_id:u.donation_id,
									id:u.id,
									blood_component_id:u.blood_component_id, 
									volume:parseInt(volume),
									current_unit:u.current_unit,
									unit_number: response.donation.donation_number,
									component_number:u.component_number,
									caducidad:u.caducidad,
									rendimiento: response.equivalent_and_platelet_performance.length > 0 ?
													index === -1 ? "" 
													: response.equivalent_and_platelet_performance[index].platelet_performance
												: "",
									equivalente: response.equivalent_and_platelet_performance.length > 0 ?
													index === -1 ? "" 
													: response.equivalent_and_platelet_performance[index].equivalent_units
												: "",
									flag: false
								}])
							}else{

								var bool = units.some(function(arr) {
								  return arr.every(function(prop, index) {
								    return u.blood_component_id === prop.blood_component_id
								  })
								});

								
								if(bool){
									
									units.some(function(arr) {
										
									  	return arr.every(function(prop, i) {
									    	return u.blood_component_id === prop.blood_component_id ?
									    		arr.push({
													unit:prop.unit+1,
													donation_id:u.donation_id,
													id:u.id,
													blood_component_id:u.blood_component_id, 
													volume:parseInt(volume),
													current_unit:u.current_unit,
													unit_number: response.donation.donation_number,
													component_number:u.component_number,
													caducidad:u.caducidad,
													rendimiento: response.equivalent_and_platelet_performance.length > 0 ?
																	index === -1 ? "" 
																	: response.equivalent_and_platelet_performance[index].platelet_performance
																: "",
													equivalente: response.equivalent_and_platelet_performance.length > 0 ?
																	index === -1 ? "" 
																	: response.equivalent_and_platelet_performance[index].equivalent_units
																: "",
													flag: false
												})
									    	: null
									  	})
									})
								}else{
									
									units.push([{
										unit:1,
										donation_id:u.donation_id,
										id:u.id,
										blood_component_id:u.blood_component_id, 
										volume:parseInt(volume),
										current_unit:u.current_unit,
										unit_number: response.donation.donation_number,
										component_number:u.component_number,
										caducidad:u.caducidad,
										rendimiento: response.equivalent_and_platelet_performance.length > 0 ?
														index === -1 ? "" 
														: response.equivalent_and_platelet_performance[index].platelet_performance
													: "",
										equivalente: response.equivalent_and_platelet_performance.length > 0 ?
														index === -1 ? "" 
														: response.equivalent_and_platelet_performance[index].equivalent_units
													: "",
										flag: false
									}])
								}
							}
						})

						var double = false;
						units.map((item)=>{
							if(item.length === 1){
								
								item.push({
									unit:item[0].unit+1,
									donation_id:item[0].donation_id,
									id:item[0].id,
									blood_component_id:item[0].blood_component_id, 
									volume:"",
									current_unit:item[0].current_unit,
									unit_number: item[0].donation_number,
									component_number:item[0].component_number,
									caducidad:item[0].caducidad,
									rendimiento:  "",
									equivalente:  "",
									flag: false
								})
							}else{
								double = true;
							}
						})

						
						this.setState({
							unit: units,
							double:double
						})
					}

					this.getOffer();
				});
			}else{
				this.getOffer();
			}

			
			if(this.props.match.params.extraction_incident_id !== '0'){
				var incident_id = this.props.match.params.extraction_incident_id;
			
				fetch(Config.default.apiGateway.URL+'incidents_extraction?id='+incident_id, {
					method: 'get',
					headers: new Headers({
						'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				})
				.then(res => {
	            if(res.ok){
	              return res.json();
	            }else{
	              res.text().then(function(result) {
	                swal('¡Error', result, 'error');
	              });
	            }})
				.then(response => {
					this.setState({
						incident_ids: response.incident_ids,
						method:'put',
						incident_id:incident_id
					})
					
					setTimeout(()=>{
						this.selectIncident();
					}, 500);
					
				})
			}
		}, 1000);
		//Verificar si el usuario tiene persmio para editar el tipo de extraccion y donacion
		var tasks = this.props.task_has_user_profiles;
		this.setState({show_enable_button:false});
		for(var i =0; i < tasks.length;i++){
			
			if(tasks[i].type === "CHANGE_EXTRACTION_TYPE"){
				this.setState({show_enable_button:true});
				break;
			}
		}

		
		
	}

	filterArrayByValues(array, values, propertyName) {
        return array.filter(function (arrayItem) {
            return values.some(function (value) {
                return value === arrayItem[propertyName];
            });
        });
    }

	getApheresisKit(){
		var selector = document.getElementById("start_hour");
		var im = new Inputmask("--:--");
		im.mask(selector);

		var selector = document.getElementById("end_hour");
		var im = new Inputmask("--:--");
		im.mask(selector);

		//apheresis_kits
		fetch(Config.default.apiGateway.URL+'apheresis_kits',{
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer ' + sessionStorage.getItem("token"),
				'Accept' 		: 'application/json',
				'Content-Type'	: 'application/json', 
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			this.setState({apheresis: response});

			setTimeout(function(){
				
				if(this.state.apheresis_kits_id !== ""  ){
					this.state.apheresis.map(function(a){
						if(a.apheresis_kit.id === this.state.apheresis_kits_id){
							this.setState({
								component_kit:a.asigned_components.components,
								asigned_kit: a.asigned_components.asigned
							})

							if(this.state.unit.length === 0){
								a.asigned_components.components.map((c, i)=>{
									this.setState({
										unit:[...this.state.unit, 
											[
												{
													unit: 1,
													donation_id:this.state.donation_id,
													blood_component_id:this.state.asigned_kit[i].blood_component_id, 
													volume:"",
													current_unit:true,
													unit_number: this.state.donation_number,
													component_number: "",
													caducidad: this.calculateExpiration(this.state.asigned_kit[i].expiration_days),
													rendimiento:"",
													equivalente:"",
													flag:false,
												},
												{
													unit: 2,
													donation_id:this.state.donation_id,
													blood_component_id:this.state.asigned_kit[i].blood_component_id, 
													volume:"",
													current_unit:true,
													unit_number: this.state.donation_number,
													component_number: "",
													caducidad: this.calculateExpiration(this.state.asigned_kit[i].expiration_days),
													rendimiento:"",
													equivalente:""
												},
											]
										]
									})
								})

							}
							setTimeout(()=>{
								a.asigned_components.asigned.map((asign)=>{
									this.state.unit.map(obj =>{
										obj.map(o => {
											if(o.blood_component_id === asign.blood_component_id){
												if(asign.flag_platelets_units){
													o.flag = true;	
												}
												
											}
										})
									});
									this.forceUpdate();
									
								});
							})	
								
						}
						
					}.bind(this))
				}
			}.bind(this), 500);
		})
	}

	getBloodBags(){
		fetch(Config.default.apiGateway.URL+'blood_bags/by_hf/'+sessionStorage.getItem('health_facilities_id'), {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer ' + sessionStorage.getItem("token"),
				'Accept'	 	: 'application/json',
				'Content-Type' 	: 'application/json'
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			this.setState({
				blood_bags: response
			})

		})
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	getObj(){
		var res = "";
		if(this.state.offer.type_extraction_name==="SANGRE TOTAL"){
			res = this.getSTObj();
		}else{//AFERESIS
			res = this.getApheresisObj();
		}
		
		return res;
	}

	getSTObj(){
		var donation = {};

		var valida = new Date(this.state.timestamp_date.split(/\//).reverse().join('/'));
		var date = moment(this.state.timestamp_date, 'DD-MM-YYYY');
		var hour = moment(this.state.timestamp_hour, 'h:mm a');
		var duration = this.state.extraction_time;

		donation.id = this.state.donation_id;
		donation.timestamp_date = valida.toString() === 'Invalid Date' ? 'Invalid date' : date.format('MM-DD-YYYY');
		donation.timestamp_hour = this.state.timestamp_hour.indexOf('-') !== -1 ? "Invalid date" : hour.format('H:mm');
		donation.offers_id = parseInt(this.props.match.params.offers_id,10);
		donation.donation_number = this.state.donation_number; //this.state.offer.item.id;
		donation.users_id = parseInt(this.state.medical_staff_id);
		donation.tube = parseInt(this.state.donation.tube,10);
		donation.arm = this.state.donation.arm;
		donation.extraction_time = duration;
		donation.volume = parseInt(this.state.volume,10);
		donation.bag_flag = parseInt(this.state.donation.bag_flag,10);
		donation.blood_bags_id = parseInt(this.state.donation.blood_bags_id,10);
		donation.lote_number = this.state.lote_number !== "" ? parseInt(this.state.lote_number, 10) : null;
		donation.local_number = this.state.lote_number_local!==""?parseInt(this.state.lote_number_local, 10):null;
		donation.incidents_ids = this.getDonationIncidents();
		
		donation.unit = [];
		
		if(this.state.unit.length > 0){
			this.state.unit.map((unit)=>{				
				unit.map((u, i)=>{
					if(i === 0){
						u.volume = parseInt(this.state.volume);
						donation.unit = [u];
					}
				})
				
			})
		}else{
			this.state.blood_bags.map(function(b){
				if(b.blood_bag.id === parseInt(this.state.donation.blood_bags_id,10)){				

					donation.unit = [{
						donation_id:this.state.donation_id,
						blood_component_id: b.blood_component_default_id, 
						volume:parseInt(this.state.volume),
						current_unit:true,
						unit_number: this.state.donation_number,
						component_number: "00",
						caducidad: this.calculateExpiration(b.blood_bag.expiration_days),
						health_facilities_id: parseInt(sessionStorage.getItem("health_facilities_id"))
					}]
				}
			}.bind(this));
		}

		return donation;
	}

	calculateExpiration(dias){
		var date = moment(this.state.timestamp_date, 'DD-MM-YYYY');
		date = date.format('MM-DD-YYYY');

		var fecha = new Date(date);

		fecha.setDate(fecha.getDate() + parseInt(dias));

		var caducidad = fecha.getDate()+'/'+(fecha.getMonth() + 1)+'/'+fecha.getFullYear();
		caducidad = moment(caducidad, 'DD-MM-YYYY');

		return caducidad.format('MM-DD-YYYY');
	}

	getApheresisObj(){
		var donation = {};
		var valida = new Date(this.state.timestamp_date.split(/\//).reverse().join('/'));

		var date = moment(this.state.timestamp_date, 'DD-MM-YYYY');
		var hour = moment(this.state.timestamp_hour, 'h:mm a');
		var start_hour = this.state.start_hour.indexOf('-') !== -1 ? "" : this.state.start_hour//*/ moment(this.state.start_hour, 'h:mm a');
		var end_hour = this.state.end_hour.indexOf('-') !== -1 ? "" : this.state.end_hour//*/moment(this.state.end_hour, 'h:mm a');
		var unit = [];

		donation.id = this.state.donation_id;
		donation.offers_id = parseInt(this.props.match.params.offers_id,10);
		donation.donation_number = this.state.donation_number;//this.state.offer.item.id;
		donation.users_id = this.state.medical_staff_id;
		donation.tube = parseInt(this.state.donation.tube,10);
		donation.bag_flag = parseInt(this.state.donation.bag_flag,10);
		donation.arm = this.state.donation.arm;
		donation.equipment_id = this.state.donation.equipment_id!==""?parseInt(this.state.donation.equipment_id,10):null;
		donation.timestamp_date = valida.toString() === 'Invalid Date' ? 'Invalid date' : date.format('MM-DD-YYYY');
		donation.timestamp_hour = this.state.timestamp_hour.indexOf('-') !== -1 ? "Invalid date" : hour.format('H:mm');
		donation.time_start = start_hour;//.format('H:mm');
		donation.time_end = end_hour;//.format('H:mm');
		donation.cycle_number = this.state.cycle_number;
		donation.apheresis_kits_id = parseInt(this.state.apheresis_kits_id,10);
		donation.lote_number = this.state.lote_number;
		donation.volume_anticoagulant = this.state.volume_anticoagulant!==""?parseInt(this.state.volume_anticoagulant,10):null;
		donation.lote_anticuagulant = this.state.lote_anticuagulant;
		donation.local_number = this.state.local_number!==""?parseInt(this.state.local_number,10):null;
		donation.platelet_performance = this.state.platelet_performance;
		
		donation.equivalent_units =  this.state.equivalent_units!==""?parseInt(this.state.equivalent_units,10):null;
		
		if(this.state.double){
			if(this.state.equivalent_units_double !== ""){
				donation.equivalent_units_double = parseInt(this.state.equivalent_units_double, 10)	
			}else{
				donation.equivalent_units_double = null
			}
		}

		donation.incidents_ids = this.getDonationIncidents();
		
		donation.proceced_blood = this.state.processed_blood !== "" ? parseInt(this.state.processed_blood, 10) : null;

		this.state.unit.map((u, i)=>{
			
			return u.map((item, j)=>{
				
				if(item.rendimiento !== "" || item.equivalente !== "" &&
					item.rendimiento !== undefined || item.equivalente !== undefined){
					item.equivalent_and_platelet_performance = [];
				}
				if(this.state.double){
					if(u[0].id === item.id){
						//delete item['id'];
					}

					item.component_number = j === 0 ? "A0" : "B0"
					item.health_facilities_id =  parseInt(sessionStorage.getItem("health_facilities_id"));
					
					if(item.volume !== ""){
						if(item.rendimiento !== "" || item.equivalente !== "" &&
							item.rendimiento !== undefined || item.equivalente !== undefined){
							item.equivalent_and_platelet_performance.push({
								platelet_performance: item.rendimiento, 
								equivalent_units: item.equivalente === "" ? null : item.equivalente, 
								bag_number: (j+1)
							});
							
						}
					
						unit.push(item)
					}
						

				}else if(j === 0){
					item.component_number = "00"
					item.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"));
					if(item.volume !== ""){
						
						if(item.rendimiento !== "" || item.equivalente !== "" &&
							item.rendimiento !== undefined || item.equivalente !== undefined){
							item.equivalent_and_platelet_performance.push({
								platelet_performance: item.rendimiento, 
								equivalent_units: item.equivalente === "" ? null : item.equivalente, 
								bag_number: 1
							});
						}

						unit.push(item)
					}
						
				}
			})			
		})

		

		donation.unit = unit;
		donation.apheresis_double = this.state.double;
		return donation;
	}

	getDonationIncidents(){
		var res=[];
		for(var i =0; i < this.state.incidents_list.length;i++){
			res.push(parseInt(this.state.incidents_list[i].incident_type.id,10));
		}
		return res;
	}

	getOffer(){
		fetch(Config.default.apiGateway.URL+'offers/'+this.props.match.params.offers_id,{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				offer:response, 
				donation_type_id:response.item.donation_type_id,
				extraction_type_id: response.item.donation_type_extraction_id,
				flag_notes: response.extraction_notes
			});
			
			this.getDonor();

			this.getExtractionConf(response.item.donation_type_extraction_id)
			this.getDonationTypes(response.item.donation_type_extraction_id);

			if(response.type_extraction_name !== 'SANGRE TOTAL'){
				this.getApheresisKit();
			}else{
				this.getBloodBags();
			}

			setTimeout(function(){
				if(this.props.match.params.donation_number === '1' && this.props.match.params.extraction_incident_id === '0'){
					this.onClickDownload();

					/*setTimeout(function(){
						this.onLabelClick();
					}.bind(this), 4000)*/
				}
			}.bind(this), 1000);
		})
	}

	getDonor(){
		var selector = document.getElementById("date_extraction_hour");
		var im = new Inputmask("--:--");
		im.mask(selector);

		this.waiting_modal.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'donors?id='+this.props.match.params.donor_id+'&offer_id='+this.props.match.params.offers_id,{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			this.waiting_modal.handleClose();
			this.setState({donor:response});

			if(this.state.donor.person.lookup_group!=="" && this.state.donor.person.lookup_group !== null){
				this.setState({show_group_rh:true});
			}

			this.calcularEdad(response.person.birthday,'birthday');
		})
	}

	getExtractionConf(id){
		fetch(Config.default.apiGateway.URL+'donation_type_extraction/'+id, {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept' 		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			
			this.setState({
				volume: response.donation_type_extraction.volumen_default
			});
		});
	}

	componentWillUnmount() {
		this.props.onRef(null)
	}

	//Evento de cambio en elementos formulario
	handleChange = (event) => {
		if(event.target.name === 'volume'){
			if(event.target.value === ""){
				this.setState({[event.target.name]: event.target.value})
			}
			if(event.target.value.length < 4){
				let regex = new RegExp("^[0-9]+$");
	
				if(regex.test(event.target.value)){
					this.setState({[event.target.name]: event.target.value})
				}					
			}
		}else{
			this.setState({[event.target.name]: event.target.value});
		}
		

		if(event.target.name === 'start_hour' || event.target.name === 'end_hour'){
			this.validateHour(event.target);
		}else if(event.target.id !== null){
			var control = document.getElementById(event.target.id);
			if(control !== null){
			  if(control.required && control.className.includes('error')){
				control.classList.remove('error');
			  }else if(control.required && event.target.value===""){
				control.classList.add('error');
			  }
			}
		}

		if(this.apheresis !== null){
			if(event.target.name === 'apheresis_kits_id'){
				this.state.apheresis.map(function(a){
					
					if(a.apheresis_kit.id === parseInt(event.target.value,10)){
						this.setState({
							component_kit:a.asigned_components.components,
							asigned_kit: a.asigned_components.asigned,
							unit:[]
						});
					}
				}.bind(this));

				setTimeout(function(){
					this.state.component_kit.map(function(c, i){

						var objIndex = this.state.unit.findIndex((obj => obj.blood_component_id === this.state.asigned_kit[i].blood_component_id));
					
						if(objIndex === -1){
							this.setState({
								unit: [...this.state.unit, 
										[{
											unit:1,
											donation_id:this.state.donation_id,
											blood_component_id:this.state.asigned_kit[i].blood_component_id, 
											volume:"", 
											current_unit:true,
											unit_number:this.state.donation_number,
											component_number: "",
											caducidad: this.calculateExpiration(this.state.asigned_kit[i].expiration_days),
											rendimiento:"",
											equivalente:"",
											flag:false
									  	},
									  	{
									  		unit:2,
											donation_id:this.state.donation_id,
											blood_component_id:this.state.asigned_kit[i].blood_component_id, 
											volume:"", 
											current_unit:true,
											unit_number:this.state.donation_number,
											component_number: "",
											caducidad: this.calculateExpiration(this.state.asigned_kit[i].expiration_days),
											rendimiento:"",
											equivalente:"",
											flag:false,
									  	}]
									  ]
							});
						}	
					}.bind(this));

					this.state.asigned_kit.map((asign)=>{
						
						this.state.unit.map(obj =>{
							obj.map(o => {
								if(o.blood_component_id === asign.blood_component_id){
									if(asign.flag_platelets_units){
										o.flag = true;	
									}
									
								}
							})
						});
						this.forceUpdate();
						
					});
				}.bind(this), 500);
				setTimeout(function(){}.bind(this), 500);
			}			
		}

	}

	//Evento para checkbox
	handleCheck = event => {
		this.setState({ [event.target.name]: event.target.checked});
	}

	getAddress(item){
		var res = "NO REGISTRADA";

		if(item.street !== ""){
			res = item.street+' C.P. '+item.postal_code+' '+item.mpio.value_name+', '+item.state.value_name;
		}

		return res;
	}

	//selected element of this.stat.donation
	onElementDonationSelected = (e)=>{
		const donation = this.state.donation;
		donation[e.target.name] = e.target.value;

		this.setState({
			donation: donation
		})

		if(e.target.id !== null){
			var control = document.getElementById(e.target.id);
			if(control !== null){
			  if(control.required && control.className.includes('error')){
				control.classList.remove('error');
			  }else if(control.required && e.target.value===""){
				control.classList.add('error');
			  }
			}
		}
		
		this.hideFields();
	}

	hideFields(){

		if(this.state.donation.bag_flag === '0'){
			const donation = this.state.donation;
			donation.blood_bags_id = "";
			this.setState({
				hideFieldsAph:true,
				apheresis_kits_id:"",
				lote_number:"",
				local_number:"",
				volume_anticoagulant:"",
				lote_anticuagulant:"",
				platelet_performance:"",
				equivalent_units:"",

				duration:"",
				lote_number_local:"",

				donation: donation,

				component_kit:[],
				asigned_kit:[]
				
			})
		}else{
			this.setState({hideFieldsAph:false});
		}
	}

	//selecciona extraction por defecto
	selectIncident(){
		
		this.state.incidents_category.map(function(i){
			if(i.key === 'EXTRACTION'){
				const incident = this.state.incident;
				incident.key   = i.key;
				incident.text = i.name;

				this.setState({
					incident:incident,
					disable_incidents_cat:true
				});

				this.getIncidentType(i.key);
			}
		}.bind(this));
	}

	onIncidentSelected = (e)=>{
		//this.handleChange(e);
		const incident = this.state[e.target.name];	

		if(e.target.name === 'incident'){
			incident.key   = e.target.value;
			incident.text  = e.target.options[e.target.selectedIndex].text

			this.setState({
				incident : incident
			});
			this.getIncidentType(e.target.value);
		
		}else{
			incident.id    = e.target.value;
			incident.text  = e.target.options[e.target.selectedIndex].text;
			this.setState({incident_type : incident});
		}
	}

	getIncidentType = (key)=>{
		fetch(Config.default.apiGateway.URL+'incidents?option='+key, {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer ' + sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			this.setState({
				incidents_type:response
			})

			response.map(function (v,i){
			
				if(this.state.incident_ids.indexOf(v.id) !== -1){
					var obj = {}, incidents_type = {};
					obj.incident = this.state.incident;
					incidents_type.id 	= v.id;
					incidents_type.text = v.name;
					obj.incident_type   = incidents_type;
					
					this.setState({
						incidents_list: [...this.state.incidents_list, obj]
					})
				}
			}.bind(this))
		})
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		

		if(control !== null){
			if(control.value === ""){
				control.classList.add('error');
				res = false;

				return res;
			}else{
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}

				res = true;
			} 

		}

		/*
		if ((this.state[refName] === "" || this.state[refName] === null || this.state[refName] === undefined)  ||
			(this.state.donation[refName] === "" || this.state.donation[refName] === undefined )) {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}*/
		
		return res;
	}

	addIncident(){
		if(this.state.incident_type.text !== undefined && this.state.incident_type.text !== ""){
			var flag = false;

			for (var i = 0; i < this.state.incidents_list.length; i++) {
				if (this.state.incidents_list[i].incident_type.text === this.state.incident_type.text) {
					flag = true;
					break
				};
			};
			
			if(flag === true){
				swal('¡El Tipo de incidente no se puede agregar!', '¡Ya se ingreso un incidente con ese tipo!', 'error');

				this.setState({
					incident_type:{id:"", text:""}
				});
			}else{
				var obj = {};
				obj.incident = this.state.incident;
				obj.incident_type = this.state.incident_type;

				if(!this.state.disable_incidents_cat){
					this.setState({incident_type:[]});
				}

				this.addToIncidentList(obj);	
			}
				
		}
	}

	addToIncidentList(incident){
		if(this.state.incidents_list.length < 3){
			this.setState({
				incidents_list: [...this.state.incidents_list, incident],
				incident_ids  : [...this.state.incident_ids, parseInt(incident.incident_type.id,10)]
			})

			if(this.state.disable_incidents_cat){
				this.setState({
					incident_type:{id:"", text:""}
				});

			}else{
				this.setState({
					incident:{key:"", text:""},
					incident_type:{id:"", text:""}
				});
			}
		}else{
			swal('info', "Sólo está permitido agregar 3 tipos de incidentes", 'info')
		}		
	}

	removeIncidetFromList(indice){
		var array = [...this.state.incidents_list];
		array.splice(indice, 1);

		var ids = [...this.state.incident_ids];
		ids.splice(indice, 1);

		this.setState({
			incidents_list: array,
			incident_ids: ids
		});
	}

	//calcular edad
	calcularEdad(fecha,control){
		var hoy = new Date();
		if(fecha !== null){
			var cumpleanos = new Date(fecha.split(/\//).reverse().join('/'));
			
			if(cumpleanos.toString() !== 'Invalid Date'){
				var edad = hoy.getFullYear() - cumpleanos.getFullYear();
				var m = hoy.getMonth() - cumpleanos.getMonth();

				if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
					edad--;
				}

				if(edad >= 0 && edad < 110){
		    	this.setState({age:edad});	
			    }else{
			    	this.setState({age:'', birthday:''});	
			    	swal('Error', 'Fecha de nacimiento incorrecta', 'error');
			    }
			}else{
				//control.classList.add('error');
				//notify.show('Error, Fecha no válida','error');
			}
		}
			
	}

	concatGroupRH(){
		var res = "";
		if(this.state.donor.offer.group_test === null){
			if(this.state.donor.person.lookup_rh==="POSITIVO"){
				res = this.state.donor.person.lookup_group+'+'
			}else{
				res = this.state.donor.person.lookup_group+'-'
			}
		}else{
			if(this.state.donor.offer.group_test.RH==="POSITIVO"){
				res = this.state.donor.offer.group_test.group+'+'
			}else{
				res = this.state.donor.offer.group_test.group+'-'
			}
		}
		if(res.length>0){
			if(this.state.donor.offer.group_test !== null){
				if(this.state.donor.offer.group_test.lectina !== null){
					var position = 1;
					res = [res.slice(0, position), this.state.donor.offer.group_test.lectina, res.slice(position)].join('');
				}
			}
		}


		return res;
	}

	openModalHistorico(e){
		e.preventDefault();
		this.modal_historico.handleShow(this.state.donor_id);
	}

	onClickDownload = (e, print=true)=>{

		this.waiting_modal.handleShow("Generando...");
		fetch(Config.default.apiGateway.URL+'donations?health_facilities_id='+sessionStorage.getItem("health_facilities_id")+"&option=", {
		  method: 'POST', // or 'PUT'
		  body: JSON.stringify({offers_id:this.state.offer.item.id}), // data can be `string` or {object}!
		  headers: new Headers({
			'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
			'Accept': 'application/json',
			'Content-Type': 'application/json;charset=UTF-8'
		  })
		})
		.then(res => {
			this.waiting_modal.handleClose();
			if(res.ok){
				return res.json()
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');	
				})
				
			}
		})
		.then(response => {
			if(response !== undefined){
				this.setState({
					donation_number: response.donation_number,
					show_num_donation:true,
					donation_id: response.id,
					disabled_element:false
				});

				if(print){
					setTimeout(function(){
						this.onLabelClick();
					}.bind(this), 1000)
				}
					
			}
		});
	}

	onHourChange(e){
		this.setState({timestamp_hour:e.target.value});
		this.validateHour(e.target);
	}

	onDateChange(e){
		var fecha = e.target.value;

		this.setState({
			timestamp_date:fecha
		});

		if(fecha.indexOf('_') === -1){
			document.getElementById('date_extraction_date').style.borderColor = "#ccc";
			document.getElementById('date_extraction_date').classList.remove("error");
		}

	}

	onLabelClick(e){
		if(this.state.donation_number === ""){
			swal('Error', 'Para generar una etiqueta debe existir un número de donación', 'error');
		}else{
			fetch(Config.default.apiGateway.URL+'html_templates?health_facilities_id='+sessionStorage.getItem("health_facilities_id")+'&file_type=label_extraction'+"&extraction_type="+this.state.offer.type_extraction_name,{ 
				method: 'get',
				headers: new Headers({
				   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				   'Accept': 'application/json',
					'Content-Type': 'application/json',
				})
			})
			.then(res => {
	            if(res.ok){
	              return res.json();
	            }else{
	              res.text().then(function(result) {
	                swal('¡Error', result, 'error');
	              });
	            }})
			.then(response => {
				if(response.res === 0){
					swal('¡Error!', "No se ha definido ninguna etiqueta para el área de extracción", 'error');
				}else{
					this.waiting_modal.handleShow('Imprimiendo Etiquetas...');

					var obj ={};
					obj.health_facilities_id = sessionStorage.getItem("health_facilities_id");
					obj.id = this.props.match.params.donation_id === '0' ? this.state.donation_id : this.props.match.params.donation_id;
					obj.file_type = "label_extraction";
					obj.nEtiqueta = [0];
					obj.name = this.state.offer.type_extraction_name == "SANGRE TOTAL"?"SANGRE_TOTAL":"AFÉRESIS";

					fetch(Config.default.apiGateway.URL+"labelsEditor", {
						method : 'post',
						body:JSON.stringify(obj),
						responseType: 'blob', //Force to receive data in a Blob Format
						headers : new Headers({
							'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
							'Content-Type': 'application/json'
						})
					})
					.then(res => {
						this.waiting_modal.handleClose();
						if(res.ok){
							return res.blob();
						}else{
			              res.text().then(function(result) {
			                swal('¡Error', result, 'error');
			                return;
			              });
			            }
					})
					.then(response => {
						if(response !== undefined){
							if(this.state.preview_print.value === "NO"){
								//PREVIEW
								var fileURL = URL.createObjectURL(response);
								window.open(fileURL);
							}else{
								//PRINTER
								var reader = new FileReader();
								reader.readAsDataURL(response); 
								reader.onloadend = function() {
									var base64data = reader.result;  
									var aux = base64data.split(',');
									socket.send('{"Operacion":"print", "Type":"label_extraction", "File": "'+aux[1]+'"}');
								}
							}
				       		this.setState({ show: false});
			       		}
					})
				}
			});
		}
	}

	labelService(e){
		e.preventDefault();
		
		if(this.props.match.params.donation_number === '0'){
			if(this.state.donation_number === ''){
				this.onClickDownload(e, false);
			}
		}
		
		setTimeout(function(){
			this.onLabelClick(e);
		}.bind(this), 1000)
		
		
				
	}

	onVolumeChange(e){

		var blood_component_id = parseInt(e.target.id.split('_')[1],10);
		var volumen = "";

		if(e.target.value.indexOf('-') !== -1){
			e.preventDefault();
		}else{
			volumen = e.target.value === "" ? "" : parseInt(e.target.value);
		}

		this.state.component_kit.map(function(c, i){
			if(this.state.asigned_kit[i].blood_component_id === blood_component_id){

				this.state.unit[i].map((u, j)=>{
					if("vol_"+u.blood_component_id+'_'+u.unit === e.target.id){
						if(volumen === ""){
							u.volume = ""
						}else{
							u.volume = volumen;
							
						}
						
					}
				})

				this.forceUpdate();
			}
		}.bind(this));
	}

	onValueChange(e, campo){
		var name = e.target.id.split('_')[0]
		var blood_component_id = parseInt(e.target.id.split('_')[1],10);
		var value = e.target.value === "" ? "" : e.target.value;

		this.state.component_kit.map(function(c, i){
			if(this.state.asigned_kit[i].blood_component_id === blood_component_id){

				this.state.unit[i].map((u, j)=>{
					if(name+"_"+u.blood_component_id+'_'+u.unit === e.target.id){
						if([campo] === ""){
							u[campo] = ""
						}else{
							
							if(name === 'equiv'){
								if(value === ""){
									u[campo] = value;
								}else{
									if(isNumeric(value)){
										u[campo] = value;
									}
								}
								
							}else{
								u[campo] = value;
							}
							
							
						}
						
					}
				})

				this.forceUpdate();
			}
		}.bind(this));
	}

	doubleCheck(e){
		if(e.target.checked){
			this.setState({
				[e.target.name]: this.state.double ? false : true
			})

			this.state.unit.map((item, i)=>{
				return item.length === 1 ?
					item.map((val)=>{
						return item.push({
							unit:val.unit+1,
							donation_id:val.donation_id,
							id:val.id,
							blood_component_id:val.blood_component_id, 
							volume:"",
							current_unit:val.current_unit,
							unit_number: this.state.donation_number,
							component_number:"00",
							caducidad:val.caducidad,
							rendimiento:"",
							equivalente:""
						})
					})
				: null
			})

		}else{
			this.setState({
				[e.target.name]: this.state.double ? false : true
			})
		}
	}

	//Mensaje de alerta, confirmar eliminacion
	deleteMsg(){
		this.modal_liberacion.handleShow(this.state.donation_id);
	};

	editOffer(event){
		event.preventDefault();
		var offers_id = this.props.match.params.offers_id;
		var donor_id = this.props.match.params.donor_id;
		var donation_id = this.state.donation_id !== undefined ? this.state.donation_id : '0';
		var extraction_incident_id = this.props.match.params.extraction_incident_id;
		var caller_id = this.props.match.params.caller_id;
		var donation_number = this.props.match.params.donation_number;
		
		var promotion = this.state.show_promotion ? '/promotion' : '';

		if(this.state.donation_id !== undefined && this.state.donation_id !== ""){
			this.props.history.push({
				pathname: promotion+"/offers/edit/"+offers_id+"/"+donor_id+"/"+donation_id+"/"+extraction_incident_id+
							"/"+caller_id+"/"+donation_number,
				state:{
					from:'extraction'
				}
			});
		}else{
			this.props.history.push({
				pathname: promotion+"/offers/edit/"+offers_id+"/"+donor_id+"/0/"+extraction_incident_id+
							"/"+caller_id+"/"+donation_number,
				state:{
					from:'extraction'
				}			
			});
		}
	}

	validateHour(campo){
		var hour = moment(campo.value, 'h:mm a');

		if(hour.format('H:mm') === "Invalid date" || campo.value.indexOf('-') !== -1){
			document.getElementById(campo.id).classList.add("error");
			document.getElementById(campo.name).style.borderColor = "red";
		}else{
			document.getElementById(campo.name).style.borderColor = "#ccc";
			document.getElementById(campo.id).classList.remove("error");
		}
	}

	validateInput(e) {
	    const re = /^[-+]?$/;
	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;

      		const index = Array.prototype.indexOf.call(form, e.target);

      		if(form.elements[index + 1] !== undefined){

      			if(form.elements[index + 1].getAttribute("disabled") !== undefined){
      				document.getElementById('double').style.boxShadow = "0 0 5px 1px rgb(255,255,255)";

      				if(form.elements[index + 1].getAttribute("name") !== null){
      					if(form.elements[index + 1].getAttribute("disabled") === null){	
	    					if(form.elements[index + 1].getAttribute("name") === 'double'){
    							form.elements[index + 1].focus();
    							form.elements[index + 1].style.boxShadow = "0 0 5px 2px rgb(104, 173, 253)";
	    					
	    					}else{
	    						form.elements[index + 1].focus();
	    					}
	    					
      					}else if(form.elements[index + 1].getAttribute("disabled") === ""){
	    					form.elements[index + 2].focus();
	    				}
      				}else{
      					if(form.elements[index + 2].getAttribute("disabled") === null)
	    					form.elements[index + 2].focus();
	    			
	    				else if(form.elements[index + 2].getAttribute("disabled") === "")
	    					form.elements[index + 3].focus();
	    				
    				}
      			}
      		}
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
	}
	  
	getDonationTypes(extraction_id){
		fetch(Config.default.apiGateway.URL+'donation_rules?option=donation_extraction&donation_extraction_id='+extraction_id,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({donation_types: response});
		})
	}

	openModalNotes(e){
		e.preventDefault();

		this.modal_notes.handleShow(
			'',
			this.state.donor.donation_id,
			'',
			this.state.offer.item.id,
			this.state.offer.item.donor_id,
			'extraction'
		)
		
	}

	async printAferesis(e, ){
		e.preventDefault();
		if(this.state.donation_number !== ""){
		  this.waiting_modal.handleShow('Imprimiendo...');
			
		  var obj ={};
		  obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
		  obj.id = this.state.donation_id;
		  obj.file_type = "apheresis_extraction";
		  obj.nEtiqueta = [0];
	
		  var type = await this.props.getDocumentType(obj.file_type);
	
		  var document;
		  if(type.print_type === 'template'){
			document = await this.props.printDocumentTemplate(obj, type.print_automatically);
		  }else if(type.print_type === 'external'){
			document = await this.props.printDocumentExternal(obj, type.print_automatically);
		  }
	
		  if(document !== undefined){
			this.waiting_modal.handleClose();
			this.setState({ show: false});
		  }else{
			this.waiting_modal.handleClose();
		  }
		  
		}else{
		  swal('¡Error!', "Debe asignar un número de donación", 'error');
		}
	  }

	//Contenido del Formulario
	render(){
		const { t } = this.props;
		return(
			<div className="col-xs-12" style={{padding:'0px'}}>
				
		        <div className="col-xs-12 status-bar" style={{textAlign:"center",color: "red", boxShadow: "2px 1px 8px -1px #888888", fontSize:"30px"}}>
	            	<label>
	            		{"EXTRACCIÓN "+this.state.offer.type_extraction_name}
	            	</label>
	            </div>

				{/*Content*/}
				<div className="col-xs-9" >
					<div className="col-xs-12 col-sm-offset-2" style={{paddingLeft:"0px"}}>
						<h4 className="theme-color">
						{ 
							this.state.donor.person.lastname1 +' '+
							this.state.donor.person.lastname2 +', '+
							this.state.donor.person.names
						}
						</h4>

						<div className="col-xs-12">
							<div className="col-xs-12 col-md-2">
								<label className="span-min">{t('content.modal_hc.birthday')}</label>
								<input className="form-control" style={{padding:"7px"}} disabled name="birthday" 
									value={moment(this.state.donor.person.birthday).format('DD/MM/YYYY') || ""} 
								type="text"/>
							</div>
							<div className="col-xs-12 col-md-1">	
								<label className="span-min">{t('content.modal_hc.age')}</label>
								<input className="form-control" disabled name="age" value={this.state.age} 
								type="text"/>
							</div>
							<div className="col-xs-12 col-md-1">
								<label className="span-min">{t('content.modal_hc.sex')}</label>
								<input className="form-control" disabled name="sex" value={this.state.donor.person.sex} 
								 type="text" style={{paddingLeft:"3px"}}/>
							</div>

							<div className="col-xs-12 col-md-2">
								<label className="span-min">Tipo documento</label>
								<input className="form-control" disabled name="document_type" 
									value={this.state.donor.document.document_type_value || ""}
								 	type="text"/>
							</div>
							<div className="col-xs-12 col-md-2">
								<label className="span-min">No. documento</label>
								<input className="form-control" disabled name="document_number" 
									value={this.state.donor.document.document !== null ? this.state.donor.document.document.document_number || "" : ""}
								 	type="text"/>
							</div>
						</div>

						<div className="col-xs-12">
							
							<div className="col-xs-12 col-sm-4 col-md-3">
								<label className="span-min">{t('content.extractions.form.date')}</label>
								<input className="form-control" name="date" id="date" disabled 
									value={ this.state.offer.timestamp_date+' '+this.state.offer.timestamp_hour}  onChange={ this.props.handleChange }/>
							</div>

							<div className="col-xs-12 col-sm-5">
								<label className="span-min">{t('content.extractions.form.convoke_place')}</label>
								<input className="form-control" name="convoke_places_name" id="convoke_places_name" 
									disabled value={ this.state.offer.convoke_places_name } 
									onChange={ this.props.handleChange }/>
							</div>
						</div>

						<div className="col-xs-12  form-group">
							<div className="col-xs-9 col-sm-10 col-md-2">
								<label className="span-min" style={{fontSize:"11px"}}>{t('content.extractions.form.donation_number')}</label>
								<input className="form-control" style={{padding:"3px",margin:"0px", fontSize:"16px"}} name="donation_type" id="donation_type" 
									disabled value={ this.state.show_num_donation ? this.state.donation_number : "" } />
							</div>

							<div className="col-xs-1 col-sm-1 col-md-1">
								<Button className="btn btn-info btn-xs" style={{marginTop:"21px"}} type="button" title="Generar Número de Donación" onClick={this.onClickDownload} 
									disabled={this.props.task_extraction.create ? 
													this.state.donation_number !== "" ? 
														true 
													: false 
												: true}>
									<SvgIcon icon={download} style={{paddingTop:"3px"}}/>
								</Button>
							</div>

							<div className="col-xs-2 col-sm-2">
								<Button className="btn btn-info" type="button" style={{marginTop:"21px"}}
									disabled={this.state.disableLiberation ?
												this.state.disableLiberation
											: this.state.donation_number === "" ? true : false}
									onClick={this.deleteMsg}>
									LIBERAR NÚMERO
								</Button>
							</div>
						</div>
					</div>

					<div className="col-xs-12 col-sm-offset-2" >
						<fieldset>
							<legend style={{width:"80%"}}>DATOS EXTRACCIÓN</legend>
							<div className="col-xs-12" style={{padding:"0px"}}>
								{this.state.offer.type_extraction_name==="SANGRE TOTAL"?
									<div className="col-xs-12 col-sm-4">
										<div className="col-xs-12">
											<span className="span-min">{t('content.extractions.form.date_extraction')}</span>
										</div>
										<div className="col-xs-6 col-sm-6" style={{paddingLeft:"0px"}}>
											<MaskedFormControl type="text" name="date_extraction_date" 
												value={this.state.timestamp_date} id="date_extraction_date" 
												mask='11/11/1111' onBlur={this.onDateChange}
												className="input-date"
												placeholder="dd/mm/yyyy" style={{padding:"5px"}}
												disabled={!this.state.can_be_edit || this.state.disabled_element} />
										</div>
										<div className="col-xs-6 col-sm-6" style={{paddingRight:"0px"}}>
											<input type="text" id="date_extraction_hour" name="date_extraction_hour"  
												data-inputmask-alias="datetime" data-inputmask-inputformat="HH:MM"  
												data-inputmask-placeholder="-" value={this.state.timestamp_hour || ""} 
												onChange={this.onHourChange} onBlur={this.onHourChange}
												style={{padding:"5px"}} disabled={!this.state.can_be_edit || this.state.disabled_element}
												className="form-control" onKeyPress={(e) => this.validateInput(e)}/>
										</div>
									</div>
								: null
								}
								<div className={this.state.offer.type_extraction_name!=="SANGRE TOTAL"?"col-xs-12 col-sm-4":"col-xs-12 col-sm-4"}>
									<span className="span-min">{t('content.extractions.form.medical_staff')}</span>
									<select className="form-control" value={ this.state.medical_staff_id } 
										onChange={ this.handleChange.bind(this) } name="medical_staff_id" id="medical_staff_id"
										disabled={this.state.donation.validated ? true : this.state.disabled_element} onKeyPress={(e) => this.validateInput(e)} >
										<option value="" disabled>Seleccionar...</option>
										{
											this.state.staff.map(function(t) {
												return <option key={t.medical_staff.id} value={t.medical_staff.id} >
															{t.medical_staff.code?t.medical_staff.code+' - ':""} 
															{' '+t.medical_staff.names+' '} 
															{t.medical_staff.lastname1?t.medical_staff.lastname1+' ': ""} 
															{t.medical_staff.lastname2?t.medical_staff.lastname2: ""}
														</option>;
											})
										}
									</select>
								</div>
								{this.state.offer.type_extraction_name!=="SANGRE TOTAL"?
									<div>
										<div className="col-xs-12 col-sm-2">
											<div className="col-xs-12">
												<span className="span-min">{t('content.extractions.form.date_extraction')}</span>
											</div>
											<div className="col-xs-6 col-sm-6" style={{paddingLeft:"0px"}}>
												<MaskedFormControl type="text" name="date_extraction_date" 
													value={this.state.timestamp_date} id="date_extraction_date" 
													mask='11/11/1111' onBlur={this.onDateChange}
													className="input-date"
													placeholder="dd/mm/yyyy" style={{padding:"5px"}} 
													disabled={!this.state.can_be_edit || this.state.disabled_element} />
											</div>
											<div className="col-xs-6 col-sm-6" style={{paddingRight:"0px"}}>
												<input type="text" id="date_extraction_hour" name="date_extraction_hour"  
													data-inputmask-alias="datetime" data-inputmask-inputformat="HH:MM"  
													data-inputmask-placeholder="-" value={this.state.timestamp_hour || ""} 
													onChange={this.onHourChange} onBlur={this.onHourChange}
													style={{padding:"5px"}} disabled={!this.state.can_be_edit || this.state.disabled_element}
													className="form-control" onKeyPress={(e) => this.validateInput(e)}/>
												
											</div>
										</div>

										<div className="col-xs-12 col-sm-1">
											<span className="span-min">{t('content.extractions.form.start_hour')}</span>
											<input type="text" id="start_hour" name="start_hour"  
													data-inputmask-alias="datetime" data-inputmask-inputformat="HH:MM"  
													data-inputmask-placeholder="-" value={this.state.start_hour || ""} 
													onChange={this.handleChange} style={{padding:"5px"}} 
													disabled={!this.state.can_be_edit || this.state.disabled_element}
													onKeyPress={(e) => this.validateInput(e)}
													className="form-control"/>

										</div>
										<div className="col-xs-12 col-sm-1">
											<span className="span-min">{t('content.extractions.form.end_hour')}</span>
											<input type="text" id="end_hour" name="end_hour"  
													data-inputmask-alias="datetime" data-inputmask-inputformat="HH:MM"  
													data-inputmask-placeholder="-" value={this.state.end_hour || ""} 
													onChange={this.handleChange} style={{padding:"5px"}} 
													disabled={!this.state.can_be_edit || this.state.disabled_element}
													onKeyPress={(e) => this.validateInput(e)}
													className="form-control"/>
										</div>
									</div>
								: null
								}
							</div>

							<div className="col-xs-12" style={{padding:"0px"}}>
								{this.state.offer.type_extraction_name!=="SANGRE TOTAL"?
									!this.state.hideFieldsAph ? 
										<div>
											<div className="col-xs-12 col-sm-2">
												<span className="span-min">{t('content.extractions.form.equipment')}</span>
												<select className="form-control" value={ this.state.donation.equipment_id || ""} 
													onChange={ this.onElementDonationSelected.bind(this) } name="equipment_id" 
													id="equipment_id" disabled={!this.state.can_be_edit || this.state.disabled_element}
													onKeyPress={(e) => this.validateInput(e)}>
													<option value="" disabled>Seleccionar...</option>
													{
														this.state.equipments.map(function(t){
															return <option key={t.equipment.id} value={t.equipment.id} >{t.equipment.name}</option>;
														})
													}
												</select>
											</div>
										</div>
									:null
								: null}
								<div className={this.state.offer.type_extraction_name!=="SANGRE TOTAL"?"col-xs-12 col-sm-2":"col-xs-12 col-sm-2"}>
									<span className="span-min">{t('content.extractions.form.arm')}</span>
									<select className="form-control" value={ this.state.donation.arm || ""} 
										onChange={ this.onElementDonationSelected.bind(this) } name="arm" id="arm"
										disabled={this.state.disabled_element} onKeyPress={(e) => this.validateInput(e)}>
										<option value="" disabled>Seleccionar...</option>
										{
											this.state.arms.map(function(t) {
												return <option key={t.id} value={t.key} >{t.name}</option>;
											})
										}
									</select>
								</div>
								<div className="col-xs-12 col-sm-1">
									<span className="span-min">{t('content.extractions.form.tube')}</span>
									<select className="form-control" required value={ this.state.donation.tube || ""} 
										onChange={ this.onElementDonationSelected.bind(this) } name="tube" id="tube"
										disabled={!this.state.can_be_edit || this.state.disabled_element} onKeyPress={(e) => this.validateInput(e)}>
										<option value="" disabled>Seleccionar...</option>
										<option value="0">Si</option>
										<option value="1">No</option>
									</select>
								</div>
								
								<div className="col-xs-12 col-sm-1">
									<span className="span-min">{t('content.extractions.st.bag')}</span>
									<select className="form-control" required value={ this.state.donation.bag_flag || ""} 
										onChange={ this.onElementDonationSelected.bind(this) } name="bag_flag" id="bag_flag"
										disabled={!this.state.can_be_edit || this.state.disabled_element} onKeyPress={(e) => this.validateInput(e)}>
										<option value="" disabled>Seleccionar...</option>
										<option value="1">Si</option>
										<option value="0">No</option>
									</select>
								</div>

								{this.state.offer.type_extraction_name!=="SANGRE TOTAL"?
									<div className="col-xs-12 col-sm-2">
							        	<span className="span-min">{t('content.extractions.apheresis.lote_number')}</span>
							  			<input className="form-control" name="lote_number" id="lote_number" 
											value={ this.state.lote_number } onChange={ this.handleChange }
											disabled={this.state.disabled_element} onKeyPress={(e) => this.validateInput(e)}/>
									</div>:!this.state.hideFieldsAph ? 

										<div className="col-xs-12 col-sm-4">
											<span className="span-min">{t('content.extractions.st.blood_bags_id')}</span>
											<select className="form-control" required value={ this.state.donation.blood_bags_id || ""} 
												onChange={ this.onElementDonationSelected.bind(this) } name="blood_bags_id" 
												id="blood_bags_id" disabled={!this.state.can_be_edit || this.state.disabled_element}
												onKeyPress={(e) => this.validateInput(e)}>
												<option value="" disabled>Seleccionar...</option>
												{
													this.state.blood_bags.map(function(t) {
														return <option key={t.blood_bag.id} value={t.blood_bag.id} >{t.blood_bag.name}</option>;
													})
												}
											</select>
										</div>
									:null
								}
							</div>

							{this.state.offer.type_extraction_name==="SANGRE TOTAL"?
								<STData  {...this.props} validate={this.validateInput} onRef={ref=>(this.stdData = ref)} handleChange={this.handleChange} state={this.state}/>

							: 	<ApheresisData  {...this.props} validate={this.validateInput} onRef={ref => (this.apheresis = ref)} handleChange={this.handleChange} 
									onElementDonationSelected={this.onElementDonationSelected} 
									onValueChange={this.onValueChange}
									onVolumeChange={this.onVolumeChange} doubleCheck={this.doubleCheck} state={this.state}/>}
						</fieldset>
						<fieldset>
							<legend style={{width:"80%"}}>INCIDENTES</legend>
							<div className="col-xs-12 col-sm-6" style={{padding:"0px"}}>
								<div className="col-xs-12 col-sm-4">
									<span className="span-min">{t('content.extractions.st.incident')}</span>
									<select className="form-control" value={ this.state.incident.key || ""} 
										onChange={ this.onIncidentSelected } name="incident" id="incident"
										disabled={this.state.disable_incidents_cat} onKeyPress={(e) => this.validateInput(e)}>
										<option value="" disabled>Seleccionar...</option>
										{
											this.state.incidents_category.map(function(t) {
												return <option key={t.id} value={t.key} >{t.name}</option>;
											})
										}
									</select>
								</div>							
								<div className="col-xs-12 col-sm-4 form-group">
									<span className="span-min">{t('content.extractions.st.select')}</span>
									<select className="form-control" value={ this.state.incident_type.id || ""} onKeyPress={(e) => this.validateInput(e)}
										onChange={ this.onIncidentSelected } name="incident_type" id="incident_type"
										disabled={!this.state.can_be_edit}>
										<option value="" disabled>Seleccionar...</option>
										{
											this.state.incidents_type.map(function(t) {
												return <option key={t.id} value={t.id} >{t.name}</option>;
											})
										}
									</select>
								</div>
								<div className="col-xs-12 col-sm-4" style={{marginTop:"18px"}}>
									<FloatingActionButton className="action-btn"  mini={true}  onClick={this.addIncident}
										disabled={!this.state.can_be_edit}
										iconStyle={{height: 25, width: 25}}>
									  	<ContentAdd/>
									</FloatingActionButton>
								</div>
								<div className="col-xs-12">
									<div className="col-xs-12 col-sm-8">
										<Table responsive hover>
											<thead>
												<tr>
													<th>{t('content.extractions.incidents.category')}</th>
													<th>{t('content.extractions.incidents.type')}</th>
													<th></th>
												</tr>
											</thead>
											<tbody>
											{
												this.state.incidents_list.map((v, i) => (
													<tr key={i}>
														<td>{v.incident.text}</td>
														<td>{v.incident_type.text}</td>
														<td>
															{this.state.can_be_edit &&
																<Button className="btn btn-info btn-xs" title="Eliminar" style={{marginRight:'3px'}} onClick={(e)=>this.removeIncidetFromList(i, e)}>
																	<SvgIcon icon={bin} style={{paddingTop:"3px"}}/>
																</Button>
															}
														</td>
													</tr>
												))
											}
											</tbody>
										</Table>
									</div>

								</div>
									
							</div>
						</fieldset>
					</div>
				</div>
				{/*AVATAR CLINIC HISTORY*/}
				<div className="col-xs-12 col-sm-3" style={{paddingTop:"5px"}}>
					<div className="col-xs-12" style={{textAlign:"center"}}>
						{this.state.show_group_rh ?
							<div className="col-xs-12 col-sm-2" >
								<h3 style={{color:'red'}}>
									{this.concatGroupRH()}
								</h3>
							</div>
						: null	}
						{this.state.donor.person.photo !== null && this.state.donor.person.photo !== undefined?
							<div className="col-xs-12 col-sm-offset-2 col-sm-10">
								<img style={{height:'170px',width:'164px'}} src={'data:image/jpeg;base64,'+this.state.donor.person.photo} alt="Donor"/>
							</div>
							:
							<div className="col-xs-12 col-sm-offset-2 col-sm-10">
								<img style={{height:'170px',width:'164px'}} src="../../../default_user.jpg" alt="USER"/>
							</div>}
					</div>
					<div className="col-xs-12" style={{textAlign:"center"}}>
						<div className="col-xs-12 col-sm-offset-2 col-sm-10">
							<span  className="span-min">{t('content.modal_hc.donation_type')}</span>
						</div>
						<div className="col-xs-12 col-sm-offset-2 col-sm-10" style={{paddingTop:"5px"}}>
							<select className="form-control" value={this.state.extraction_type_id}
								name="extraction_type_id" id="extraction_type_id" disabled>
								{this.state.extraction_types.map(function(t) {
									return <option key={t.donation_type_extraction.id} value={t.donation_type_extraction.id} >{t.lookup_value}</option>;
								})}
							</select>
						</div>
						<div className="col-xs-12 col-sm-offset-2 col-sm-10" style={{paddingTop:"5px"}}>
						<select className="form-control" value={this.state.donation_type_id|""}
								name="donation_type_id" id="donation_type_id" disabled>
								{this.state.donation_types.map(function(t) {
									return <option key={t.donation_type.id} value={t.donation_type.id} >{t.donation_type_lookup}</option>;
								})}
							</select>
						</div>

						
						{this.state.show_enable_button?
						<div className="col-xs-12 col-sm-offset-2 col-sm-10" style={{paddingTop:"5px"}}>
							<Button className="btn btn-info" type="button" onClick={(e)=>this.editOffer(e)}>
								EDITAR
							</Button>
						</div>:null}
						<div className="col-xs-12 col-sm-offset-2 col-sm-10" style={{paddingTop:"5px"}}>
							<span className="span-min">{t('content.modal_hc.donor_number')}</span>
							<input className="form-control" disabled name="donor_number" value={this.state.donor.donor.donor_number} 
							type="text"/>
						</div>
					</div>
				</div>
				<div className="col-xs-12" style={{textAlign:"center",fontSize:".8em",padding:'0px'}}>
					<div className="form-group" >
						{this.state.offer.type_extraction_name !== "SANGRE TOTAL" &&
							<button type="button" className="toolIcon" onClick={(e)=>this.printAferesis(e)}>
								<SvgIcon size={40} icon={print} />
								<div className="col-xs-12">
									<span>Imprimir</span>
								</div>
							</button>
						}
						<button type="button" className="toolIcon" onClick={(e)=>this.labelService(e)}>
							<SvgIcon size={40} icon={ic_local_offer} />
							<div className="col-xs-12">
								<span>{t('toolbar.labels')}</span>
							</div>
						</button>

						<button className="toolIcon"
							onClick={(e)=>this.openModalNotes(e)}>
							<SvgIcon size={40} icon={pencilSquareO} style={this.state.flag_notes ? {color:'green'} : {}}/>
							<div className="col-xs-12">
								<span>{t('toolbar.save_notes')}</span>
							</div>
						</button>
					</div>
				</div>
				<ModalLiberacion {...this.props} onRef={ref => (this.modal_liberacion = ref)} />
				<ModalHistorico {...this.props} onRef={ref => (this.modal_historico = ref)} />
				<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
				<ModalPrintLabel {...this.props} onRef={ref => (this.modal_print_label = ref)}/>
				<ModalNotes {...this.props} onRef={ref => (this.modal_notes = ref)} updateNotesID={this.updateDonationNotesID}/>
				<Notifications />
			</div>
		);
	}
}

export default FormExtractions;